import request from "@/utils/request";

// // 设置数据
// localStorage.setItem('key', 'value');

// // 获取数据
// const value = localStorage.getItem('key');

// // 删除数据
// localStorage.removeItem('key');
// 登录
export function codelogin(data) {
    return request({
        url: "/api/codelogin",
        method: "post",
        data,
    });
}
// 上传文件
export function getupload(data) {
    return request({
        url: "/api/upload",
        method: "post",
        data,
    });
}

// 修改用户信息
export function useredit(data) {
    return request({
        url: "/api/useredit",
        method: "post",
        data,
    });
}

//创建项目
export function ainewProjectadd(data) {
    return request({
        url: "/api/ainewProjectadd",
        method: "post",
        data,
    });
}
//查询项目
export function ainewProjectlist(data) {
    return request({
        url: "/api/ainewProjectlist",
        method: "post",
        data,
    });
}
// 项目详情
export function ainewProjectinfo(data) {
    return request({
        url: "/api/ainewProjectinfo",
        method: "post",
        data,
    });
}

// 删除项目
export function ainewProjectremove(data) {
    return request({
        url: "/api/ainewProjectremove",
        method: "post",
        data,
    });
}

// 修改项目
export function ainewProjectedit(data) {
    return request({
        url: "/api/ainewProjectedit",
        method: "post",
        data,
    });
}

// 查询章节
export function ainewProjectChapterlist(data) {
    return request({
        url: "/api/ainewProjectChapterlist",
        method: "post",
        data,
    });
}

// 新增章节
export function ainewProjectChapteradd(data) {
    return request({
        url: "/api/ainewProjectChapteradd",
        method: "post",
        data,
    });
}
// 修改章节
export function ainewProjectChapteredit(data) {
    return request({
        url: "/api/ainewProjectChapteredit",
        method: "post",
        data,
    });
}

// 删除章节
export function ainewProjectChapterremove(data) {
    return request({
        url: "/api/ainewProjectChapterremove",
        method: "post",
        data,
    });
}
//  查询章节详情
export function ainewProjectChapterinfo(data) {
    return request({
        url: "/api/ainewProjectChapterinfo",
        method: "post",
        data,
    });
}

// 新增剧本
export function ainewChapterScriptadd(data) {
    return request({
        url: "/api/ainewChapterScriptadd",
        method: "post",
        data,
    });
}
// 查询剧本
export function ainewChapterScriptlist(data) {
    return request({
        url: "/api/ainewChapterScriptlist",
        method: "post",
        data,
    });
}

// 修改剧本
export function ainewChapterScriptedit(data) {
    return request({
        url: "/api/ainewChapterScriptedit",
        method: "post",
        data,
    });
}
// 查询风格分类
export function ainewStyleCategorylist(data) {
    return request({
        url: "/api/ainewStyleCategorylist",
        method: "post",
        data,
    });
}
// 查询风格
export function ainewPlatformStylelist(data) {
    return request({
        url: "/api/ainewPlatformStylelist",
        method: "post",
        data,
    });
}
// AI生成剧本
export function aitext(data) {
    return request({
        url: "/api/aitext",
        method: "post",
        data,
    });
}

// 获取音色数据
export function ainewTimbrelist(data) {
    return request({
        url: "/api/ainewTimbrelist",
        method: "post",
        data,
    });
}
//  主体提取剧本内容
export function aizhuti(data) {
    return request({
        url: "/api/aizhuti",
        method: "post",
        data,
    });
}

// 查询章节主体
export function ainewChapterSubjectlist(data) {
    return request({
        url: "/api/ainewChapterSubjectlist",
        method: "post",
        data,
    });
}

// 查询章节主体详情
export function ainewChapterSubjectinfo(data) {
    return request({
        url: "/api/ainewChapterSubjectinfo",
        method: "post",
        data,
    });
}
// 新增主体
export function ainewChapterSubjectadd(data) {
    return request({
        url: "/api/ainewChapterSubjectadd",
        method: "post",
        data,
    });
}

//修改主体
export function ainewChapterSubjectedit(data) {
    return request({
        url: "/api/ainewChapterSubjectedit",
        method: "post",
        data,
    });
}
//删除主体
export function ainewChapterSubjectremove(data) {
    return request({
        url: "/api/ainewChapterSubjectremove",
        method: "post",
        data,
    });
}
//查询ai 模型列表
export function ainewModellist(data) {
    return request({
        url: "/api/ainewModellist",
        method: "post",
        data,
    });
}
// 生成主体图
export function aiphoto(data) {
    return request({
        url: "/api/aiphoto",
        method: "post",
        data,
    });
}
//  ai 生成分镜数据
export function aifenjing(data) {
    return request({
        url: "/api/aifenjing",
        method: "post",
        data,
    });
}
// 查询分镜列表
export function ainewChapterStoryFenjinglist(data) {
    return request({
        url: "/api/ainewChapterStoryFenjinglist",
        method: "post",
        data,
    });
}
//分镜详情
export function ainewChapterStoryFenjinginfo(data) {
    return request({
        url: "/api/ainewChapterStoryFenjinginfo",
        method: "post",
        data,
    });
}

// 新增分镜列表
export function ainewChapterStoryFenjingadd(data) {
    return request({
        url: "/api/ainewChapterStoryFenjingadd",
        method: "post",
        data,
    });
}

// 修改分镜
export function ainewChapterStoryFenjingedit(data) {
    return request({
        url: "/api/ainewChapterStoryFenjingedit",
        method: "post",
        data,
    });
}
// 删除分镜
export function ainewChapterStoryFenjingremove(data) {
    return request({
        url: "/api/ainewChapterStoryFenjingremove",
        method: "post",
        data,
    });
}

//分镜生成故事板
export function aifenjingmp3(data) {
    return request({
        url: "/api/aifenjingmp3",
        method: "post",
        data,
    });
}
// 修改分镜台词
export function ainewChapterStoryFenjingedittaici(data) {
    return request({
        url: "/api/ainewChapterStoryFenjingedittaici",
        method: "post",
        data,
    });
}
// 试听
export function shiting(data) {
    return request({
        url: "/api/shiting",
        method: "post",
        data,
    });
}
// 分镜生成图片
export function aifenjingphoto(data) {
    return request({
        url: "/api/aifenjingphoto",
        method: "post",
        data,
    });
}
//故事板 新增视频参数
export function ainewChapterStoryFenjingVideoadd(data) {
    return request({
        url: "/api/ainewChapterStoryFenjingVideoadd",
        method: "post",
        data,
    });
}
//故事板 查询视频参数
export function ainewChapterStoryFenjingVideolist(data) {
    return request({
        url: "/api/ainewChapterStoryFenjingVideolist",
        method: "post",
        data,
    });
}
//故事板 新增ai视频
export function aivideo(data) {
    return request({
        url: "/api/aivideo",
        method: "post",
        data,
    });
}
//故事板 查询视频详情
export function ainewChapterStoryFenjingVideoinfo(data) {
    return request({
        url: "/api/ainewChapterStoryFenjingVideoinfo",
        method: "post",
        data,
    });
}
//故事板 修改视频详情
export function ainewChapterStoryFenjingVideoedit(data) {
    return request({
        url: "/api/ainewChapterStoryFenjingVideoedit",
        method: "post",
        data,
    });
}

export function ainewChapterStoryFenjingVideoremove(data) {
    return request({
        url: "/api/ainewChapterStoryFenjingVideoremove",
        method: "post",
        data,
    });
}
//  故事板生成视频
export function getaivideo(data) {
    return request({
        url: "/api/aivideo",
        method: "post",
        data,
    });
}
// 查询章节 最后的成片
export function ainewChapterFinalVideolist(data) {
    return request({
        url: "/api/ainewChapterFinalVideolist",
        method: "post",
        data,
    });
}
//合并视频
export function hebingvideo(data) {
    return request({
        url: "/api/hebingvideo",
        method: "post",
        data,
    });
}

// 查询ai厂商
export function ainewModelVendorslist(data) {
    return request({
        url: "/api/ainewModelVendorslist",
        method: "post",
        data,
    });
}

//模型版本
export function ainewModelVersionslist(data) {
    return request({
        url: "/api/ainewModelVersionslist",
        method: "post",
        data,
    });
}
//模型规格
export function ainewOutputSpecslist(data) {
    return request({
        url: "/api/ainewOutputSpecslist",
        method: "post",
        data,
    });
}
//模型计费规格
export function ainewPricingRuleslist(data) {
    return request({
        url: "/api/ainewPricingRuleslist",
        method: "post",
        data,
    });
}
// 用户信息
export function userInfo(data) {
    return request({
        url: "/api/userInfo",
        method: "post",
        data,
    });
}

// 获取配置信息
export function ainewAiSettinginfo(data) {
    return request({
        url: "/api/ainewAiSettinginfo",
        method: "post",
        data,
    });
}
//  查询用户 邀请记录明细

export function daUserInviteDetaillist(data) {
    return request({
        url: "/api/daUserInviteDetaillist",
        method: "post",
        data,
    });
}
// 查询点数流水 变动
export function aiPointsFlowlist(data) {
    return request({
        url: "/api/aiPointsFlowlist",
        method: "post",
        data,
    });
}

// 查询用户余额明细
export function daUserBalanceDetaillist(data) {
    return request({
        url: "/api/daUserBalanceDetaillist",
        method: "post",
        data,
    });
}
// 获取会员卡
export function ainewMemberCardlist(data) {
    return request({
        url: "/api/ainewMemberCardlist",
        method: "post",
        data,
    });
}

// 使用卡密
export function useraiCard(data) {
    return request({
        url: "/api/useraiCard",
        method: "post",
        data,
    });
}

//查询充值算力列表
export function aiPointslist(data) {
    return request({
        url: "/api/aiPointslist",
        method: "post",
        data,
    });
}

// 支付接口
export function alipaywebpay(data) {
    return request({
        url: "/api/alipaywebpay",
        method: "post",
        data,
    });
}

// 注册登录相关接口////////
// 账号密码登录
export function h5login(data) {
    return request({
        url: "/api/h5login",
        method: "post",
        data,
    });
}
// 验证码登录
export function phonelogin(data) {
    return request({
        url: "/api/phonelogin",
        method: "post",
        data,
    });
}

// 忘记密码
export function findPassword(data) {
    return request({
        url: "/api/findPassword",
        method: "post",
        data,
    });
}
// 注册
export function registerUser(data) {
    return request({
        url: "/api/registerUser",
        method: "post",
        data,
    });
}

// 修改密码
export function changePassword(data) {
    return request({
        url: "/api/changePassword",
        method: "post",
        data,
    });
}

// 修改用户信息（昵称、头像等）
export function editUserInfo(data) {
    return request({
        url: "/api/editUserInfo",
        method: "post",
        data,
    });
}

// 发送验证码
export function aisendCode(data) {
    return request({
        url: "/api/aisendCode",
        method: "post",
        data,
    });
}